import { CharAPICall } from 'api/charAPICall';
import { DatCache } from 'api/datCache';
import { LogStream } from 'generics/common';
import { SettingsInjections } from 'generics/settingsInjections';

LogStream.enable( "APICALLDEBUG" );

////////////////////////////////////////////
// class UserstatAPICall
class UserstatAPICall  extends CharAPICall {
  normalizeResponse( resp )  {
    return resp.result || resp.response;
  }


  getInterfaceUrl()  {
    return SettingsInjections.getUsedCircuit().userstat_server.replace("/web", "/char");
  }
};

export function AchievementSearch( appid, userid )
{
  const action = userid ? "AnoGetUnlocks" : "GetUnlocks";

  const callSearch = new UserstatAPICall(action);

  callSearch.appendHeader("appid", appid);
  callSearch.appendHeader("forAchievementServiceOnly", "on");

  if (userid)
    callSearch.appendHeader("userid", userid);

  callSearch.append("withUnprogressed", true);

  return callSearch.RPC().then( (resp) =>  {
    LogStream( "APICALLDEBUG" ).info(`AchievementSearch(${appid}) - got response:`, resp);
    return resp.unlocks;
  });
}

export function AchievementGetInfo( appid )
{
  const language = SettingsInjections.getUsedLocale().name;

  let callGetInfo = new UserstatAPICall("GetUserStatDescList");
  callGetInfo.setRetryPolicy( 5, 100, 500 );

  callGetInfo.appendHeader("appid", appid);
  callGetInfo.appendHeader("language", language );

  return callGetInfo.POST().then( (resp) =>  {
    LogStream( "APICALLDEBUG" ).info(`AchievementGetInfo(${appid}) - got response:`, resp);
    return resp.unlocks;
  });
}

export function AchivementFindById ( achivAppId, achivId )
{
  const language = SettingsInjections.getUsedLocale().name;

  return AchievementInfoCacheResolver.resolve(
    achivAppId, language
  ).then( ( achievements ) =>  {
    return Object.values(  achievements
                ).filter(  (achievement)  => ( achievement.name === achivId ) )[0];
  });
}

////////////////////////////////////////////
class AchievementCache extends DatCache  {
  constructor()  {
    super({name:"achievementhash", timeoutMin: 5});
  }

  fetch( key, [  appid, userid  ] )  {
    return AchievementSearch( appid, userid );
  }
}

export const AchievementCacheResolver = new AchievementCache();

////////////////////////////////////////////
class AchievementInfoCache extends DatCache  {
  constructor()  {
    super({name:"achievementinfohash", timeoutMin: 60});
  }

  fetch( key, [  appid, language  ] )  {
    return AchievementGetInfo( appid );
  }
}

export const AchievementInfoCacheResolver = new AchievementInfoCache();